import type { ParticipantStatus } from '@zrc/core';

export function Status({ s }: { s: ParticipantStatus }) {
  return (
    <span className={`status status-${s}`} aria-label={`status ${s}`}>
      {s}
    </span>
  );
}

export function readFileText(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => resolve(String(r.result ?? ''));
    r.onerror = () => reject(r.error);
    r.readAsText(file, 'utf-8');
  });
}

export function fmtTime(iso?: string): string {
  if (!iso) return '';
  const d = new Date(iso);
  return d.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit', second: '2-digit' });
}
